export default __webpack_public_path__ + "static/media/logo.db36153e.svg";